import { render, staticRenderFns } from "./ProjectInputDescriptionPopOver.vue?vue&type=template&id=b060880c&"
import script from "./ProjectInputDescriptionPopOver.vue?vue&type=script&lang=js&"
export * from "./ProjectInputDescriptionPopOver.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInputDescriptionPopOver.vue?vue&type=style&index=0&id=b060880c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports